import React from 'react';
import Header from '../src/Components/Header.jsx';
import About from '../src/Components/About.jsx';
import Education from '../src/Components/Education.jsx';
import Experiences from './Components/Experiences.jsx';
import Certifications from './Components/Certifications.jsx';
import Skills from '../src/Components/Skills.jsx';
import Projects from '../src/Components/Projects.jsx';
import Contact from '../src/Components/Contact.jsx';

const App = () => {
  return (
    <div>
      <Header />
      <About />
      <Education />
      <Experiences />
      <Certifications />
      <Skills />
      <Projects />
      <Contact />
    </div>
  );
};

export default App;
